import { render, staticRenderFns } from "./LeaderboardSetComponent.vue?vue&type=template&id=4c474b12&scoped=true&"
import script from "./LeaderboardSetComponent.vue?vue&type=script&lang=ts&"
export * from "./LeaderboardSetComponent.vue?vue&type=script&lang=ts&"
import style0 from "./LeaderboardSetComponent.vue?vue&type=style&index=0&id=4c474b12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c474b12",
  null
  
)

export default component.exports